import { CompanyAddress } from 'ggApp/types/graphql';
import React from 'react';
import {
    AddressText,
    BoxWrap,
    Description,
    IconBadgeWrapper,
    IconWrapper,
    InfoBoxText,
    TextWrapper,
    Title,
} from './styled';

const CompanyInfoBox = ({
    icon,
    title,
    text,
    description,
    address,
}: {
    icon: JSX.Element;
    title: string;
    text: string;
    description?: string;
    address?: CompanyAddress;
}): JSX.Element => {
    return (
        <BoxWrap>
            <IconBadgeWrapper>
                <IconWrapper>{icon}</IconWrapper>
            </IconBadgeWrapper>
            <TextWrapper>
                <Title>{title}</Title>
                {address ? (
                    <AddressText>
                        {address.line1} {address.line2} <br />
                        {address.zip}, {address.city} <br />
                        {address.country}
                    </AddressText>
                ) : (
                    <InfoBoxText>{text}</InfoBoxText>
                )}
                {description ? <Description>{description}</Description> : null}
            </TextWrapper>
        </BoxWrap>
    );
};

export default CompanyInfoBox;
